import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { SelectCycleDisclaimer } from './SelectCycleDisclaimer';
import { SelectPlanDisclaimer } from './SelectPlanDisclaimer';
import { EclipsePackagePickerSteps } from '../../../types';
export const StepDisclaimer = function (_temp) {
  let {
    isMobile
  } = _temp === void 0 ? {} : _temp;
  const module = useCurrentModule();
  const currentStep = module.internals.hooks.useCurrentStep();
  if (currentStep === EclipsePackagePickerSteps.SELECT_PLAN) {
    return /*#__PURE__*/React.createElement(SelectPlanDisclaimer, {
      isMobile: isMobile
    });
  }
  if (currentStep === EclipsePackagePickerSteps.SELECT_CYCLE) {
    return /*#__PURE__*/React.createElement(SelectCycleDisclaimer, {
      isMobile: isMobile
    });
  }
  if (currentStep === EclipsePackagePickerSteps.CHECKOUT) {
    return null;
  }
  return null;
};
//# sourceMappingURL=StepDisclaimer.js.map